/**
 * TimePicker Component
 *
 * Time input with quick buttons for common selections.
 * Includes "Sekarang" (now), "+15m", "+30m" quick buttons.
 */

interface TimePickerProps {
	value: string;
	onChange: (value: string) => void;
	label?: string;
	id?: string;
	disabled?: boolean;
}

/**
 * Get current time in HH:mm format
 */
function getCurrentTime(): string {
	const now = new Date();
	return now.toTimeString().slice(0, 5);
}

/**
 * Add minutes to current time and return in HH:mm format
 */
function addMinutesToNow(minutes: number): string {
	const now = new Date();
	now.setMinutes(now.getMinutes() + minutes);
	return now.toTimeString().slice(0, 5);
}

export function TimePicker({
	value,
	onChange,
	label = 'Waktu',
	id = 'time-picker',
	disabled = false,
}: TimePickerProps) {
	const quickButtons = [
		{ label: 'Sekarang', getTime: () => getCurrentTime() },
		{ label: '+15m', getTime: () => addMinutesToNow(15) },
		{ label: '+30m', getTime: () => addMinutesToNow(30) },
	];

	return (
		<div className="space-y-2">
			{label && (
				<label
					htmlFor={id}
					className="block text-sm font-medium text-gray-700"
				>
					{label}
				</label>
			)}
			<div className="flex flex-wrap gap-2">
				<input
					type="time"
					id={id}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					disabled={disabled}
					className="flex-1 min-w-[120px] px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition disabled:bg-gray-100 disabled:cursor-not-allowed"
				/>
				<div className="flex gap-1">
					{quickButtons.map((btn) => (
						<button
							key={btn.label}
							type="button"
							onClick={() => onChange(btn.getTime())}
							disabled={disabled}
							className="px-3 py-2 text-sm font-medium text-blue-600 bg-blue-50 rounded-lg hover:bg-blue-100 transition disabled:opacity-50 disabled:cursor-not-allowed"
						>
							{btn.label}
						</button>
					))}
				</div>
			</div>
		</div>
	);
}
